import axios from '@/api/api'
import axiosB from 'axios'
import qs from 'qs'
export default {
  data() {
    /* eslint-disable */
    return {
      // 设置属性
      mixinViewModuleOptions: {
        requestMethod: 'post',
        deleteMethod: 'delete',
        createdIsNeed: true,       // 此页面是否在创建时，调用查询数据列表接口？
        activatedIsNeed: false,    // 此页面是否在激活（进入）时，调用查询数据列表接口？
        getDataListURL: '',       // 数据列表接口，API地址
        getDataListIsPage: true, // 数据列表接口，是否需要分页？
        deleteURL: '',            // 删除接口，API地址
        deleteIsBatch: false,     // 删除接口，是否需要批量？
        deleteIsBatchKey: 'id',   // 删除接口，批量状态下由那个key进行标记操作？比如：pid，uid...
        exportURL: '',            // 号码导出接口，API地址
        rechrageURL: '',            // 充值记录导出接口，API地址 
        exportTelInfoURL:'',// 号码详情导出接口，API地址 
        reactiveURL:'',// 号码激活导出接口，API地址 
      },
      // 默认属性
      dataForm: {},               // 查询条件
      dataList: [],               // 数据列表
      order: '',                  // 排序，asc／desc
      orderField: '',             // 排序，字段
      page: 1,                    // 当前页码
      limit: 10,                  // 每页数
      total: 0,                   // 总条数
      dataListLoading: false,     // 数据列表，loading状态
      dataListSelections: [],     // 数据列表，多选项
      addOrUpdateVisible: false,   // 新增／更新，弹窗visible状态
      pageSizes: [10, 20, 50, 100],
      buttonList: [],
      exportHandleMethod: 'get',
      exportTelInfoHandleMethod: 'get'
    }
    /* eslint-enable */
  },
  created() {
    if (this.mixinViewModuleOptions.createdIsNeed) {
      this.query()
    }
  },
  activated() {
    if (this.mixinViewModuleOptions.activatedIsNeed) {
      this.query()
    }
  },
  methods: {
    // 获取数据列表
    query() {
      this.dataListLoading = true
      axios[this.mixinViewModuleOptions.requestMethod](
        this.mixinViewModuleOptions.getDataListURL,
        this.mixinViewModuleOptions.requestMethod == "get" ? {
          params: {
            page: this.mixinViewModuleOptions.getDataListIsPage ? this.page : null,
            pageSize: this.mixinViewModuleOptions.getDataListIsPage ? this.limit : null,
            ...this.dataForm
          }
        } : {
          // order: this.order,
          // orderField: this.orderField,
          page: this.mixinViewModuleOptions.getDataListIsPage ? this.page : null,
          pageSize: this.mixinViewModuleOptions.getDataListIsPage ? this.limit : null,
          ...this.dataForm
        }
      ).then(({ data: res }) => {
        this.dataListLoading = false
        if (!res.success) {
          this.dataList = []
          this.total = 0
          debugger;
          return this.$message.error(res.msg)
        }
        this.dataList = this.mixinViewModuleOptions.getDataListIsPage ? res.response.data : res.response
        this.total = this.mixinViewModuleOptions.getDataListIsPage ? res.response.dataCount : 0
      }).catch((err) => {
        this.dataListLoading = false
      })
    },
    // 多选
    dataListSelectionChangeHandle(val) {
      this.dataListSelections = val
    },
    // 排序
    dataListSortChangeHandle(data) {
      if (!data.order || !data.prop) {
        this.order = ''
        this.orderField = ''
        return false
      }
      this.order = data.order.replace(/ending$/, '')
      this.orderField = data.prop.replace(/([A-Z])/g, '_$1').toLowerCase()
      this.query()
    },
    // 分页, 每页条数
    pageSizeChangeHandle(val) {
      this.page = 1
      this.limit = val
      this.query()
    },
    // 分页, 当前页
    pageCurrentChangeHandle(val) {
      this.page = val
      this.query()
    },
    getDataList: function () {
      this.page = 1
      this.query()
    },
    //重置表单
    resetForm() {
      this.$refs['lineForm'].resetFields();
    },
    // 新增 / 修改
    addOrUpdateHandle(id) {
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        // this.$refs.addOrUpdate.dataForm.id = id
        this.$refs.addOrUpdate.init(id)
      })
    },
    // 关闭当前窗口
    closeCurrentTab(data) {
      var tabName = this.$store.state.contentTabsActiveName
      this.$store.state.contentTabs = this.$store.state.contentTabs.filter(item => item.name !== tabName)
      if (this.$store.state.contentTabs.length <= 0) {
        this.$store.state.sidebarMenuActiveName = this.$store.state.contentTabsActiveName = 'home'
        return false
      }
      if (tabName === this.$store.state.contentTabsActiveName) {
        this.$router.push({ name: this.$store.state.contentTabs[this.$store.state.contentTabs.length - 1].name })
      }
    },
    // 删除
    deleteHandle(id) {
      // if (this.mixinViewModuleOptions.deleteIsBatch && !id && this.dataListSelections.length <= 0) {
      //   return this.$message({
      //     message: this.$t('prompt.deleteBatch'),
      //     type: 'warning',
      //     duration: 500
      //   })
      // }
      this.$confirm("是否删除当前选中数据", "提示！", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: 'warning'
      }).then(() => {
        this.$http[this.mixinViewModuleOptions.deleteMethod](
          `${this.mixinViewModuleOptions.deleteURL}${this.mixinViewModuleOptions.deleteIsBatch ? '' : '?id=' + id}`,
          this.mixinViewModuleOptions.deleteIsBatch ? {
            'data': id ? [id] : this.dataListSelections.map(item => item[this.mixinViewModuleOptions.deleteIsBatchKey])
          } : {}
        ).then(({ data: res }) => {
          if (!res.success) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: res.msg || "删除成功",
            type: 'success',
            duration: 1500,
            onClose: () => {
              this.query()
            }
          })
        }).catch(() => { })
      }).catch(() => { })
    },
    // 号码导出
    exportHandle() {
      var params = qs.stringify({
        // 'token': Cookies.get('token'),
        ...this.dataForm
      })
      // window.location.href = `${process.env.VUE_APP_BASE_URL}${this.mixinViewModuleOptions.exportURL}?${params}`
      axiosB({
        method: this.exportHandleMethod,
        url: this.exportHandleMethod == 'get' ? this.mixinViewModuleOptions.exportURL + '?' + params : this.mixinViewModuleOptions.exportURL,
        data: this.exportHandleMethod == 'get' ? undefined : this.dataForm,
        headers: {
          Authorization: `Bearer ${this.$store.state.token}`,
        },
        responseType: 'blob'
      }).then(res => {
        try {
          const blob = new Blob([res.data], { type: res.headers['content-type'] }); // 创建 blob 对象 type 可以使用 headers 里面的 contentType
          const a = document.createElement("a");
          const url = window.URL.createObjectURL(blob); // 创建媒体流 url ，详细了解可自己查 URL.createObjectURL（推荐 MDN ）
          a.href = url;
          a.style.display = "none";
          const date = new Date();
          const fileName = `号码列表${date.getFullYear()}${date.getMonth() + 1}${date.getDate()}.xlsx`;
          a.download = fileName;
          document.body.appendChild(a);
          a.click();
          a.parentNode.removeChild(a);
          window.URL.revokeObjectURL(url);
        }
        catch (e) {
          debugger;
        }
      })
    },
    exportTelInfoHandle() {
      var params = qs.stringify({
        // 'token': Cookies.get('token'),
        ...this.dataForm
      })
      // window.location.href = `${process.env.VUE_APP_BASE_URL}${this.mixinViewModuleOptions.exportURL}?${params}`
      axiosB({
        method: this.exportTelInfoHandleMethod,
        url: this.exportTelInfoHandleMethod == 'get' ? this.mixinViewModuleOptions.exportTelInfoURL + '?' + params : this.mixinViewModuleOptions.exportTelInfoURL,
        data: this.exportTelInfoHandleMethod == 'get' ? undefined : this.dataForm,
        headers: {
          Authorization: `Bearer ${this.$store.state.token}`,
        },
        responseType: 'blob'
      }).then(res => {
        try {
          const blob = new Blob([res.data], { type: res.headers['content-type'] }); // 创建 blob 对象 type 可以使用 headers 里面的 contentType
          const a = document.createElement("a");
          const url = window.URL.createObjectURL(blob); // 创建媒体流 url ，详细了解可自己查 URL.createObjectURL（推荐 MDN ）
          a.href = url;
          a.style.display = "none";
          const date = new Date();
          const fileName = `号码列表${date.getFullYear()}${date.getMonth() + 1}${date.getDate()}.xlsx`;
          a.download = fileName;
          document.body.appendChild(a);
          a.click();
          a.parentNode.removeChild(a);
          window.URL.revokeObjectURL(url);
        }
        catch (e) {
          debugger;
        }
      })
    },
    // 号码导出
    rechrageexportHandle() {
      var params = qs.stringify({
        ...this.dataForm
      })
      axiosB({
        method: 'get',
        url: this.mixinViewModuleOptions.rechrageURL + '?' + params,
        headers: {
          Authorization: `Bearer ${this.$store.state.token}`,
        },
        responseType: 'blob'
      }).then((err) => {
        debugger
        const blob = new Blob([err.data], { type: err.headers['content-type'] });
        const a = document.createElement("a");
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        a.style.display = "none";
        const date = new Date();
        const fileName = `充值报表${date.getFullYear()}${date.getMonth() + 1}${date.getDate()}.xlsx`;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.parentNode.removeChild(a);
        window.URL.revokeObjectURL(url);
      })
    },
    jihuoexportHandle() {
      var params = qs.stringify({
        ...this.dataForm
      })
      axiosB({
        method: 'get',
        url: this.mixinViewModuleOptions.reactiveURL + '?' + params,
        headers: {
          Authorization: `Bearer ${this.$store.state.token}`,
        },
        responseType: 'blob'
      }).then((err) => {
        debugger
        const blob = new Blob([err.data], { type: err.headers['content-type'] });
        const a = document.createElement("a");
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        a.style.display = "none";
        const date = new Date();
        const fileName = `号码激活报表${date.getFullYear()}${date.getMonth() + 1}${date.getDate()}.xlsx`;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.parentNode.removeChild(a);
        window.URL.revokeObjectURL(url);
      })
    },
  }
}
